import React, {FC, useEffect, useState} from "react";
import {useLocale} from "@/contexts/localeContext.tsx";
import PaginatedSearchableSelectField from "@/components/selection-field/paginated-searchable-select-field.tsx";
import {TranslationKeys} from "@/contexts/TranslationKeys.ts";
import Label from "@/components/label/label.tsx";
import {useSelector} from "react-redux";
import {getPermissionNames} from "@/services/permissionService.ts";
import {useFormikContext} from "formik";

interface linkGroupProfileProps {
    onNext: () => void,
    onBack?: () => void,
    setStepDescriptions: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
    title: string
}

const LinkGroupProfile: FC<linkGroupProfileProps> = ({onNext, onBack, title, setStepDescriptions }) => {
    const { translate } = useLocale();
    const [isNextEnabled, setIsNextEnabled] = useState(false)
    const userLoginProfileId = useSelector((state: any) => (state.userInfo.profileId));
    const { values, setFieldValue } = useFormikContext<any>();

    useEffect(() => {
        if (values.profileId) {
            setIsNextEnabled(true)
        }
    }, [values.profileId]);

    const onRowSelected = async (item) => {
        if (item?.value) {
            await setFieldValue("profileId", parseInt(item?.value));
            await setFieldValue("profileName", item?.label);
            setIsNextEnabled(true);
            return;
        }
        setIsNextEnabled(false);
    }

    const handleNext = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        setStepDescriptions(prev => ({...prev, profileName: values.profileName}))
        onNext();
    }

    const handleBack = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        if (onBack) {
            onBack();
        }
    }

    return <div className="pt-3 pr-3 h-full relative">
            <span className={`mb-3 text-portal-blue-primary-shade2 text-xl font-semibold`} >
                {title}
            </span>
            <div className="flex flex-col pr-3">
                <div className="pb-4">
                    <div className="flex flex-row justify-between" id='startIpLabelId'>
                        <Label htmlFor={"profileId"} className={"block mb-2 text-m font-medium text-gray-900 dark:text-white"}>
                            {translate.byKey(TranslationKeys.selectPermission)}
                        </Label>
                    </div>
                    <PaginatedSearchableSelectField
                        name={translate.byKey(TranslationKeys.type)}
                        key={"profileId"}
                        accessor='profileId'
                        searchAccessor='profileName'
                        dataMethod={(listParameters) => getPermissionNames(listParameters, userLoginProfileId)}
                        onSelect={(_, item) => onRowSelected(item)}
                        selectedItemLabel={values.profileName ? values.profileName : ''}/>
                </div>
            </div>
            <div className="flex justify-end w-full absolute bottom-0 pr-3 pb-3">
                <button
                    className={`py-1 px-5 mt-3 secondary secondary-inverse mr-2 py-1 px-5 ${onBack ? '' : 'invisible'}`}
                    type="button"
                    onClick={handleBack}>{translate.byKey(TranslationKeys.back)}</button>
                <button
                    className={`py-1 px-5 mt-3 secondary  ${isNextEnabled ? 'text-white bg-portal-blue-primary-shade2' : 'secondary-disabled cursor-not-allowed'}`}
                    type="button"
                    disabled={!isNextEnabled}
                    onClick={handleNext}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
}

export default LinkGroupProfile;
